import React, { createContext, useState } from "react";

export const signInContext = createContext();
const SigninContext = ({ children }) => {
  const [formData, setFormData] = useState({
    individualEmail: "",
    individualPassword: "",
    orgName: "",
    orgEmail: "",
    orgPassword: ""
  });
  const [user, setUser] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [isTypeSelect, setIsTypeSelect] = useState("individual");
  const [plan, setPlan] = useState("");
  const [userMail, setUserMail] = useState("");
  const [orgnization, setOrgnization] = useState("");
  const [sdk, setSdk] = useState(null);
  const [addPinSelect, setAddPinSelect] = useState(true);
  return (
    <signInContext.Provider
      value={{
        formData,
        setFormData,
        isTypeSelect,
        setIsTypeSelect,
        user,
        setUser,
        orgnization,
        setOrgnization,
        authToken,
        setAuthToken,
        plan,
        setPlan,
        userMail,
        setUserMail,
        sdk,
        setSdk,
        addPinSelect,
        setAddPinSelect,
      }}
    >
      {children}
    </signInContext.Provider>
  );
};

export default SigninContext;
